module.exports = __webpack_public_path__ + "img/bankB-icon.70ad11c7.svg";